module.exports = __webpack_public_path__ + "img/lightbulb-fill.b556ab06.svg";